import React from 'react';
import { SocialIcon } from '@yme/atoms/social-icon';
import { buildKey } from '@yme/utils/common';
import { SocialIconsStyled } from './styled';
export function SocialIcons({ socialLinks }) {
    return (React.createElement(SocialIconsStyled, null, socialLinks?.map(({ link, iconPath, altText }, index) => {
        const splittedLinkText = link.split('//');
        const uniqueLabel = splittedLinkText.length > 1 ? splittedLinkText[1].split('.')[0] : link;
        return (React.createElement(SocialIcon, { link: link, image: iconPath, key: buildKey(iconPath, index), altText: altText, uniqueLabel: uniqueLabel }));
    })));
}
